import { useQuery } from '@tanstack/react-query'
import { getCompanyPosition } from 'api/company/position/getCompanyPosition'
import { positionKey } from './keys'

export function useCompanyPosition(
  positionId: number | null,
  staleTime?: number
) {
  return useQuery({
    queryKey: positionKey(positionId),
    queryFn: () => getCompanyPosition(positionId),
    enabled: !!positionId,
    staleTime: staleTime ?? 0,
  })
}
